import React from "react";
import { Text } from "components";

export default ({ message }) => (
  <Text size="14px" margin="-22px 0 6px" color="red">
    {message}
  </Text>
);
